import React from "react";
import { CircularProgress } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";

const Loading = ({ size }) => {
  return (
    <Grid container justifyContent="center" sx={{ height: "100%" }}>
      <Grid md={12} xs={12} sx={{ textAlign: "center" }} alignContent="center">
        <CircularProgress color="primary" size={size || "30px"} />
      </Grid>
    </Grid>
  );
};

export default Loading;
